<template>
  <div class="app-shell" id="appShell" ref="appShell">
    <keep-alive :include="cachedViews">
      <router-view />
    </keep-alive>
    <div class="toast" id="gcToast" ref="toast"></div>
  </div>
</template>

<script>
import { installBackHandler } from './utils/nav'

export default {
  name: 'GcApp',
  computed: {
    cachedViews() {
      return ['Home', 'Category', 'Ranking']
    }
  },
  created() {
    this.$store.dispatch('initApp')
    installBackHandler()
  },
  mounted() {
    window.$gcToast = this
  },
  beforeDestroy() {
    if (window.$gcToast === this) {
      window.$gcToast = null
    }
  },
  methods: {
    showToast(message) {
      const el = this.$refs.toast
      if (!el) return
      if (this._toastTimer) clearTimeout(this._toastTimer)
      el.textContent = message
      el.classList.add('show')
      this._toastTimer = setTimeout(() => el.classList.remove('show'), 1800)
    }
  }
}
</script>

<style scoped>
.toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.8);
  background: rgba(0, 0, 0, 0.82);
  color: #fff;
  padding: 12px 24px;
  border-radius: 24px;
  font-size: 0.85rem;
  z-index: 9999;
  pointer-events: none;
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  letter-spacing: 0.3px;
  white-space: nowrap;
}
.toast.show {
  opacity: 1;
  transform: translate(-50%, -50%) scale(1);
}
</style>

<style>
@import './styles/common.css';
</style>
